import { Channel, Actions as StreamApiActions } from '../actions/streamApi';

export const WEBSOCKET_ENDPOINTS = {
  STREAM_SERVICE: process.env.REACT_APP_STREAM_SERVICE_URL,
  STOMP_SERVICE: process.env.REACT_APP_STREAM_SERVICE_STOMP_URL,
} as const;

export interface ChannelConfig {
  actionType: StreamApiActions;
  getSubscriptionKey: (data: any) => string;
  validateData: (data: any) => boolean;
  getTopic: (data: any) => string;
  processMessage: (parsedData: any, originalData: any) => any;
  shouldAutoUnsubscribe?: (parsedData: any) => boolean;
}

export const CHANNEL_CONFIG: Partial<Record<Channel, ChannelConfig>> = {
  [Channel.SENSOR_READINGS]: {
    actionType: StreamApiActions.RECEIVED_DEVICE_READING,
    getSubscriptionKey: (data: any) =>
      `${Channel.SENSOR_READINGS}-${data.vendor}-${data.uuid}`,
    validateData: (data: any) => {
      if (!data.vendor || !data.uuid) {
        console.warn(
          'Vendor and UUID are required to subscribe to sensor readings'
        );
        return false;
      }
      return true;
    },
    getTopic: (data: any) =>
      `/topic/subscribe/${Channel.SENSOR_READINGS}/${data.uuid}/${data.vendor}`,
    processMessage: (parsedData: any, originalData: any) => {
      return {
        type: StreamApiActions.RECEIVED_DEVICE_READING,
        data: parsedData.data,
      };
    },
  },
  [Channel.INCIDENT_INFO]: {
    actionType: StreamApiActions.RECEIVED_SUBSCRIBED_INCIDENT,
    getSubscriptionKey: (data: any) =>
      `${Channel.INCIDENT_INFO}-${data.equipmentId || 'none'}-${
        data.spaceId || 'none'
      }`,
    validateData: (data: any) => {
      if (!data.equipmentId && !data.spaceId) {
        console.warn(
          'Equipment ID or Space ID is required to subscribe to incident info'
        );
        return false;
      }
      return true;
    },
    getTopic: (data: any) => {
      if (data.equipmentId) {
        return `/topic/subscribe/${Channel.INCIDENT_INFO}/equipment/${data.equipmentId}`;
      } else if (data.spaceId) {
        return `/topic/subscribe/${Channel.INCIDENT_INFO}/space/${data.spaceId}`;
      }
      return '';
    },
    processMessage: (parsedData: any, originalData: any) => {
      return {
        type: StreamApiActions.RECEIVED_SUBSCRIBED_INCIDENT,
        data: parsedData.data.incidentInfoDto,
      };
    },
  },
} as const;
